import React from "react";
import { useTranslation } from "react-i18next";

import WPHeading from "../../../../../packages/WPHeading";

import { USERS_TABLE_HEADER_CONFIG } from "./UsersTableHeader.constants";

import "./SelectedUsersHeader.scss";

const SelectedUsersHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="selected-users-header">
      {USERS_TABLE_HEADER_CONFIG.map(
        ({ field, minWidth, flex = 1, id, type }) => (
          <div
            key={id}
            className={`header-cell ${type}`}
            style={{
              minWidth:
                typeof minWidth === "number" ? `${minWidth}px` : minWidth,
              flex,
            }}
          >
            {type !== "remove" ? (
              <WPHeading
                size="xSmall"
                type="default"
                color="var(--du-color-black_70)"
              >
                {t(`ValueStrings.${field}`)}
              </WPHeading>
            ) : null}
          </div>
        ),
      )}
    </div>
  );
};

export default SelectedUsersHeader;
